import AppOnboarding from '@/components/AppOnboarding';
import Header from '@/components/Header';
import { LayoutDetector } from '@/components/LayoutDetector';
import PageWrapper from '@/components/Main/PageWrapper';
import Redirect from '@/components/Redirect';
import useHabitatTour from '@/components/TourOnboarding/useHabitatTour';
import HomeLayout from '@/layouts/Home';
import { useSelector } from '@/redux/helper';
import { selectShouldShowAppOnboarding } from '@/redux/selectors/users';

import HomeContent from './HomeContent';

const Home = () => {
  return (
    <HomeLayout>
      <HomeContent />
    </HomeLayout>
  );
};

const HomeDesktop = () => {
  // initialize habitat tour logic (desktop, ATM only for educators)
  useHabitatTour();
  return (
    <>
      <Header />
      <PageWrapper>
        <Home />
      </PageWrapper>
    </>
  );
};

const HomeWithLayout = () => {
  const active = useSelector((state) => state?.user?.subscription?.active);
  const userRole = useSelector((state) => state?.user?.role);
  const isRealEmail = useSelector((state) => state?.user?.isRealEmail);
  const showShowAppOnboarding = useSelector(selectShouldShowAppOnboarding);
  const isLoggedIn = useSelector((state) => state?.user?.logged);
  if (isLoggedIn && !active && userRole === 'user' && !isRealEmail) {
    return <Redirect to="/emailVerification" />;
  }

  if (showShowAppOnboarding) {
    return <AppOnboarding />;
  }

  return (
    <LayoutDetector
      title="Habitats"
      breakPoint={1023} // keep it as stable as possible in mobile device to prevent layout change when orientation changes
      desktop={<HomeDesktop />}
      mobile={<Home />}
    />
  );
};

export default HomeWithLayout;
